import { NgModule } from '@angular/core';
import { LayoutModule } from '../ui-components/layout/layout.module';
import { RouterModule } from '@angular/router';
import { InvalidPermissionsComponent } from './invalid-permissions.component';

@NgModule({
  imports: [
    LayoutModule,
    RouterModule,
  ],
  declarations: [
    InvalidPermissionsComponent,
  ],
  exports: [
    InvalidPermissionsComponent,
  ]
})
export class InvalidPermissionsModule { }
